import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { useIframeRenderData } from './IframeRenderDataContext';

interface AuthRenderData {
  authToken?: string;
  tenantId?: string;
  orgSlug?: string;
}

interface AuthContextValue {
  tenantId: string;
  authToken: string;
  orgSlug: string;
}

const AuthContext = createContext<AuthContextValue>({ tenantId: '', authToken: '', orgSlug: '' });

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const renderData = useIframeRenderData<AuthRenderData>();

  const value = useMemo(
    () => ({
      tenantId: renderData?.tenantId ?? '',
      authToken: renderData?.authToken ?? '',
      orgSlug: renderData?.orgSlug ?? '',
    }),
    [renderData?.tenantId, renderData?.authToken, renderData?.orgSlug]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuthContext = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }

  return context;
};
